import { Pipe, PipeTransform } from '@angular/core';
import { IBulkEdit } from '@account-users/account/models/LicensePermissionList';

@Pipe({
  name: 'bulkUserPipe',
})
export class BulkUserPipe implements PipeTransform {
  transform(bulkUser: IBulkEdit, successUsers: IBulkEdit[]): boolean {
    return successUsers.some((user) => user.userId === bulkUser.userId);
  }
}
